import { MessageSquare, Sparkles, Users } from 'lucide-react';

import type { TemplateAr } from '../../template-data';

export const identifyHighValueLeadPrioritySalesRoutingAr: TemplateAr = {
  name: 'رصد العميل المحتمل عالي القيمة + توجيه مبيعات بأولوية',
  description:
    'الذكاء الاصطناعي يرصد العملاء المحتملين من فئة المؤسسات ويوجّههم فوراً لكبار مندوبي المبيعات بسياق كامل.',
  category: 'ذكاء الإيرادات',
  workflow: [
    { icon: MessageSquare, label: 'استفسار محتمل' },
    { icon: Sparkles, label: 'الـ AI يقيّم' },
    { icon: Users, label: 'توجيه بأولوية', final: true },
  ],
  detailDescription: {
    paragraph1:
      'وجّه العميل المحتمل عالي القيمة لأفضل مندوبيك فوراً، مو لأول مندوب يفضى. الـ AI يقرأ نطاق الشركة، وعدد الموظفين، ومؤشرات الميزانية، ولغة الاستعجال، ومستوى النضج التقني، عشان يقيّم جودة العميل المحتمل. عميل فئة المؤسسات يتوجّه بأولوية لكبار المندوبين، والاستفسار الصغير يوصل للمندوب المبتدئ أو للأتمتة.',
    paragraph2:
      'درجات التقييم وقرارات التوجيه تلقاها في CRM عندك، والسياق كامل معها. ومندوبك يجيه إشعار Slack بالفرصة الساخنة، وملخص يجهّزه الـ AI معه. والـ AI يتعلّم من الصفقات اللي تكسبها، ويرفع دقة التقييم باستمرار.',
  },
  benefits: [
    'ما تفوتك فرصة عالية القيمة',
    'عميل المؤسسات يوصل لأفضل من يغلق الصفقة',
    'مندوبك يدخل والسياق كامل معه',
    'التوجيه الذكي يقصّر وقت الإغلاق',
    'التحويل من عميل محتمل لعميل فعلي يرتفع',
    'تستغل طاقة فريق مبيعاتك بالكامل، تلقائياً',
  ],
};
